import { render } from "./NoCancel.vue?vue&type=template&id=f047c67a"
import script from "./NoCancel.vue?vue&type=script&lang=js"
export * from "./NoCancel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__